import { useWindowSize } from 'react-use';
import { useEffect } from 'react';

type UseWindowResizeOptions = {
  enabled?: boolean;
};

export const useWindowResize = (
  onResize: (size: { width: number; height: number }) => void,
  { enabled = true }: UseWindowResizeOptions = {},
) => {
  const { width, height } = useWindowSize();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    onResize({ width, height });
  }, [width, height, enabled, onResize]);
};
